import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { EmbedIssueNavigatorSkeleton } from '@jira/platform__skeletons/src/ui/issue-navigator/components/embed-app.tsx';
import { issueNavigatorGlobalIssueListEmbedRoute } from '@jira/router-routes__issue-navigator-routes/src/issueNavigatorGlobalIssueListEmbedRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getCommonGlobalResources } from './common/getCommonGlobalResources.tsx';
import { getRouteReporting } from './common/getRouteReporting.tsx';
import { issueNavigatorEmbedPageEntryPoint } from './ui/index.tsx';

export const issueNavigatorGlobalIssueListEmbedRouteEntry: Route = createEntry(
	issueNavigatorGlobalIssueListEmbedRoute,
	() => ({
		group: 'issue-navigator',
		apdexIgnoreParams: ['jql'],
		meta: {
			capability: NIN_NEW_ISSUE_NAVIGATOR,
			reporting: getRouteReporting(),
		},
		skeleton: EmbedIssueNavigatorSkeleton,
		resources: [...getCommonGlobalResources()],
		layout: chromelessLayout,
		entryPoint: () =>
			fg('jira_global_issue_list_embed')
				? issueNavigatorEmbedPageEntryPoint
				: notFoundPageEntrypoint,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
